/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountBillingQueryMasterAccounts extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("MasterAccountBillingQueryMasterAccounts");
    }

    getFixupPrototypeFunction() { return MasterAccountBillingQueryMasterAccounts.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountBillingQueryMasterAccounts>): MasterAccountBillingQueryMasterAccounts {
        let obj = Object.assign(new MasterAccountBillingQueryMasterAccounts(), model);
        MasterAccountBillingQueryMasterAccounts.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountBillingQueryMasterAccounts>): MasterAccountBillingQueryMasterAccounts {
        if (!model) return null;
        return MasterAccountBillingQueryMasterAccounts.newInstance(<MasterAccountBillingQueryMasterAccounts> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountBillingQueryMasterAccounts) {
        if (!obj) return;

        models.MasterAccountBillingQueryMasterAccounts.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountBillingQueryMasterAccounts): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, MasterAccountBillingQueryMasterAccounts.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * ID of master accounts
     */
    master_account_ids: Array<string>;

}
